import baseReducer from "../../base/store/reducer";
import constants from "./constants";

export default (state, action) => {
  const newState = baseReducer(state, action, constants);

  const { type, payload } = action;

  switch (type) {
    case constants.SET_WORKABLE_OBJECTS:
      return { ...newState, workableObjects: payload.workableObjects };
    default:
      return newState;
  }
};
